import React from 'react';
import useForm from '../../utils/useForm';
import { generate_use_form_schema } from '../../steps/formStep';
import { useTranslation } from 'react-i18next';
import {Button, Card} from '../ui';
import NeoInfo from '../neoInfo';
import i18n from 'i18next';
import Form from "../jo-components/misc/form/form";
import {iframeScrollTo} from "../../utils/scroll";
import {ErrorMessage} from "../jo-components/misc/message/message";
import './form.css';



export default function TicketForm({ fields, onSubmit, currency, pricing, attendeeId, formErrorsBackend = {}, eventCountry = 'gb' }) {
	const { t } = useTranslation();

	// TODO: get price in cents from pyvar
	// since there are weird currencies with 3 decimals
	const price_cents = pricing?.price ? pricing.price / 100 : null;
	const price = price_cents ? new Intl.NumberFormat(
		i18n.language.replace("_", "-"),
		{ style: 'currency', currency, currencyDisplay: 'narrowSymbol' }
	).format(price_cents) : null;
	const info_data = { info: t('widget.ticketForm.warning', { price }) };

	let schema = React.useRef(generate_use_form_schema(fields));

	const [form, setFormValue, setFormObject, , formErrors, onValidate, onChangeErrors] = useForm(schema.current, {
		validateOnChange: false,
		clearOnChange: true,
		onChange: () => {}
	});

	const isEmpty = React.useMemo(() => {
		return Object.values(form).every(value => value === null || value === '');
	},[form])

	const formHasChanged = React.useMemo(() => {
		return Boolean(!fields.find(field => field['value'] !== form[field.key]));
	},[fields])

	const isInvalid = React.useMemo(() => {
		return Boolean(Object.keys(formErrors).length);
	},[formErrors])

	const isDisabledSubmit = React.useMemo(() => {
		return isEmpty || isInvalid || formHasChanged;
	},[isEmpty,isInvalid,formHasChanged])

	const displayErrorsMessage = React.useMemo(() => {
		return Boolean(Object.keys(formErrors).length);
	},[formErrors])

	const _onSubmit = React.useCallback(() => {
		if (isDisabledSubmit) {
			return;
		}
		let { valid } = onValidate();

		if (!valid) {
			setTimeout(() => {
				iframeScrollTo(document.querySelector('.wz-neo-layout'));
			}, 0);
			return;
		}
		onSubmit({data: {
			attendees: {
				[attendeeId]: form
			},
			buyer: {}
		}});
	},[form, onSubmit, isDisabledSubmit, onValidate]);

	React.useEffect(() => {
		if (Object.keys(formErrorsBackend).length) {
			onChangeErrors({...formErrorsBackend});
			iframeScrollTo(document.querySelector(`.wz-neo-layout`));
		}
	},[formErrorsBackend]);

	return (
			<>
				{ price && <NeoInfo config={info_data} className="wz-ticket-form-message wz-ticket-form-message-no-margin"/>}
				<div className='wz-ticket-form-container'>
					{displayErrorsMessage && <ErrorMessage config={{
						error_messages: {
							title: t('widget.front_error_message.title'),
							body: t('widget.front_error_message.description')
						}
					}}/>}
					<Card
						title={t('widget.updateTicketForm.title')}
						subtitle={t('widget.updateTicketForm.subtitle')}
					>
						<Form
							form={form}
							formIndex={attendeeId}
							setFormValue={setFormValue}
							setFormObject={setFormObject}
							fields={fields}
							formErrors={formErrors}
							country={eventCountry}
						/>
						<div className="wz-neo-ticket-form-footer">
							<Button
								disabled={isEmpty || isInvalid || formHasChanged}
								onClick={_onSubmit}
							>
								{t('widget.ticketForm.validate')}
							</Button>
						</div>
					</Card>
				</div>
			</>
		)
}
